import React from 'react'
import { Paper, TableContainer, Table, TableHead, TableCell, useTheme, TableRow, TableBody, Tooltip } from '@mui/material'
import moment from 'moment'
import { RAJESH_TRANSPORT } from '../../../../../helper/companyIdhardcode'

const BranchReceiveExcel = (props) => {
    const { loginData, filterData, columnSummaryDefs, reportData, selectedFields,UseFormattedLRinReports,loginCountryId } = props
    const theme = useTheme()
    const { tableHeaderColor } = theme
    const filterHeader = [
        { name: "Company", field: 'CompanyName' },
        { name: "From Receive Date", field: 'FromDate' },
        { name: "To Receive Date", field: 'ToDate' },
        { name: "Transfer From Branch ", field: 'fromBranchName' },
        { name: "Received By Branch", field: 'toBranchName' },
        { name: "Select Vehicle Number", field: 'VehicleNo' },
        { name: "Payment Type", field: 'payment' },
        { name: "Report View", field: 'Report' },
    ]
    const mainHeader = ['sno', 'LRNO', 'ChallanNo', 'ReceiptDate', 'Sender', 'SenderGSTN', 'RecName', 'ReceiverGSTN', 'ItemDetails']
    if (UseFormattedLRinReports === 3) {
        const lrIndex = mainHeader.indexOf('LRNO');
        if (lrIndex !== -1) {
          mainHeader.splice(lrIndex + 1, 0, 'FormattedLRNO');
        }
      }
    const filteredHeaders = columnSummaryDefs.filter(header => mainHeader.includes(header.field));
    return (
        <TableContainer component={Paper} className='scroll' sx={{
            maxHeight: '50vh', marginBottom: "5px",
            display: 'none'
        }} >
            <Table id="BranchTransferReceived" sx={{ minWidth: '1400px' }} stickyHeader size="small" aria-label="a dense table">
                <TableHead style={{ position: `sticky`, top: `0` }}>
                    <TableRow >
                        <TableCell className="reportTD" style={{ fontWeight: '500', textAlign: 'left' }} colSpan={Math.floor(columnSummaryDefs.length / 2)}>
                            <h3 style={{ paddingLeft: '5px', minHeight: '36px', fontSize: '28px', }}>Report For: Branch Transfer Received Report</h3>
                        </TableCell>
                        <TableCell className="reportTD" style={{ fontWeight: '500', textAlign: 'right' }} colSpan={columnSummaryDefs.length - Math.floor(columnSummaryDefs.length / 2)}>
                            <h3 style={{ paddingLeft: '5px', minHeight: '36px', fontSize: '28px' }}>Company Name : {loginData?.strCompanyName}</h3>
                        </TableCell>
                    </TableRow>
                    <TableRow >
                        <TableCell className="reportTD" style={{ fontWeight: '500', textAlign: 'left' }} colSpan={Math.floor(columnSummaryDefs.length / 2)}>
                            <h3 style={{ paddingLeft: '5px', minHeight: '36px', fontSize: '24px', }}>Transfer Time : {moment(new Date()).format('ddd,HH:mm,DD-MMM-YY')}</h3>
                        </TableCell>
                        <TableCell className="reportTD" style={{ fontWeight: '500', textAlign: 'right' }} colSpan={columnSummaryDefs.length - Math.floor(columnSummaryDefs.length / 2)}>
                            <h3 style={{ paddingLeft: '5px', minHeight: '36px', fontSize: '24px', }}>Report View: Detailed</h3>
                        </TableCell>
                    </TableRow>
                    <TableRow >
                        {filterHeader.map((val, index) => (
                            <TableCell style={{
                                minHeight: "36px",
                                backgroundColor: tableHeaderColor?.isHeadingColor,
                                color: '#444',
                                fontSize: '24px',
                                fontWeight: '600',
                                textAlign: 'left',
                            }}
                                colSpan={index !== 3 ? Math.floor(columnSummaryDefs.length / 8) : columnSummaryDefs.length - (Math.floor(columnSummaryDefs.length / 8) * 7)}

                            >
                                {val.name}
                            </TableCell>
                        ))}
                    </TableRow>
                    <TableRow >
                        {filterHeader.map((val, index) => (
                            <TableCell style={{
                                minHeight: "36px",
                                color: '#444',
                                fontSize: '24px',
                                textAlign: 'left',
                            }}
                                colSpan={index !== 3 ? Math.floor(columnSummaryDefs.length / 8) : columnSummaryDefs.length - (Math.floor(columnSummaryDefs.length / 8) * 7)}

                            >
                                {filterData[val.field]}
                            </TableCell>
                        ))}
                    </TableRow>
                    <TableRow >
                        <TableCell colSpan={17}></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell style={{
                            minHeight: "36px",
                            backgroundColor: tableHeaderColor?.isHeadingColor,
                            color: '#454646',
                            fontSize: '24px',
                            fontWeight: '700',
                            textAlign: 'left',
                        }}
                            colSpan={columnSummaryDefs.length}
                        >
                            Branch Transfer Received Report
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {reportData.map((row, index) => {
                        return row.isRowData ?
                            <TableRow key={`TD-${index}`} sx={{ verticalAlign: 'top' }}>
                                <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '24px', paddingTop: '12px', }}>{row.sno}</TableCell>
                                <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '24px', paddingTop: '12px', maxWidth: '100px' }}>
                                    {UseFormattedLRinReports===2?row.FormattedLRNO:row.LRNO}&nbsp;
                                </TableCell>
                                <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '24px', paddingTop: '12px', maxWidth: '100px' }}>
                                    {row.ManualLRNo}&nbsp;
                                </TableCell>
                                {
                                 UseFormattedLRinReports===3&&   
                                <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '24px', paddingTop: '12px', maxWidth: '100px' }}>
                                    {row.FormattedLRNO}&nbsp;
                                </TableCell>
                                }
                                <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '24px', paddingTop: '12px', }}>{row.ChallanNo}</TableCell>
                                <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '24px', paddingTop: '12px' }}>
                                    {row.ReceiptDate}
                                </TableCell>
                                <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '24px', paddingTop: '12px' }}>
                                    {row.ReceiptTime}
                                </TableCell>
                                {selectedFields.hasOwnProperty('Sender') &&
                                    <>
                                        <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '24px', paddingTop: '12px', maxWidth: '120px' }}>
                                            {row.Sender}
                                        </TableCell>
                                        <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '24px', paddingTop: '12px', maxWidth: '120px' }}>
                                            {row.SenderMobileNo}
                                        </TableCell>
                                    </>
                                }
                                {selectedFields.hasOwnProperty('SenderGSTN') &&
                                    <> 
                                    {loginCountryId!==2&&
                                        <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '24px', paddingTop: '12px', maxWidth: '150px' }}>
                                            {row.SenderGSTN}
                                        </TableCell>
                                    }
                                        <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '24px', paddingTop: '12px', maxWidth: '150px' }}>
                                            {row.SenderEmailID}
                                        </TableCell>
                                    </>
                                }
                                {selectedFields.hasOwnProperty('RecName') &&
                                    <>
                                        <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '24px', paddingTop: '12px', maxWidth: "100px" }}>
                                            {row.RecName}
                                        </TableCell>
                                        <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '24px', paddingTop: '12px', maxWidth: "100px" }}>
                                            {row.RecMobileNo}
                                        </TableCell>
                                    </>
                                }
                                {selectedFields.hasOwnProperty('ReceiverGSTN') &&
                                    <>
                                    {loginCountryId!==2&&
                                        <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '24px', paddingTop: '12px', maxWidth: '150px' }}>
                                            {row.ReceiverGSTN}
                                        </TableCell>
                                    }
                                        <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '24px', paddingTop: '12px', maxWidth: '150px' }}>
                                            {row.ReceiverEmailID}
                                        </TableCell>
                                    </>
                                }
                                {selectedFields.hasOwnProperty('ItemDetails') &&
                                    <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '24px', paddingTop: '12px', }}>{row.ItemDetails}</TableCell>
                                }
                                <TableCell style={{ minHeight: "36px", textAlign: 'right', fontSize: '24px', paddingTop: '12px', }}>{row.Units}</TableCell>
                                <TableCell style={{ minHeight: "36px", textAlign: 'right', fontSize: '24px', paddingTop: '12px', }}>{row.Freight}</TableCell>
                                {selectedFields.hasOwnProperty('CartageAmount') &&
                                    <TableCell style={{ minHeight: "36px", textAlign: 'right', fontSize: '24px', paddingTop: '12px', }}>{row.CartageAmount}</TableCell>
                                }
                                {selectedFields.hasOwnProperty('HamaliCharge') &&
                                    <TableCell style={{ minHeight: "36px", textAlign: 'right', fontSize: '24px', paddingTop: '12px', }}>{row.HamaliCharge}</TableCell>
                                }
                                {selectedFields.hasOwnProperty('OtherCharges') &&
                                    <TableCell style={{ minHeight: "36px", textAlign: 'right', fontSize: '24px', paddingTop: '12px', }}>{row.OtherCharges}</TableCell>
                                }
                                {selectedFields.hasOwnProperty('Valuation') &&
                                    <TableCell style={{ minHeight: "36px", textAlign: 'right', fontSize: '24px', paddingTop: '12px', }}>{row.Valuation}</TableCell>
                                }
                                {selectedFields.hasOwnProperty('BookingGST') &&
                                    <TableCell style={{ minHeight: "36px", textAlign: 'right', fontSize: '24px', paddingTop: '12px', }}>{row.BookingGST}</TableCell>
                                }
                                {loginData.intCompanyID !== RAJESH_TRANSPORT &&
                                    <TableCell style={{ minHeight: "36px", textAlign: 'right', fontSize: '24px', paddingTop: '12px', }}>{row.NetAmount}</TableCell>
                                }
                                {loginData?.intCompanyID === RAJESH_TRANSPORT &&
                                    <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '24px', paddingTop: '12px' }}>
                                        {row.Remarks || ''}
                                    </TableCell>
                                }
                            </TableRow>
                            : row.isTotalRow ?
                                <TableRow key={`TR-${index}`}>
                                    <TableCell style={{ minHeight: "36px", backgroundColor: tableHeaderColor?.isTotalColor, fontSize: '24px', fontWeight: 'bold', textAlign: 'right', color: '#444' }} colSpan={filteredHeaders.length}>{row.caption}</TableCell>
                                    <TableCell style={{ minHeight: "36px", backgroundColor: tableHeaderColor?.isTotalColor, fontSize: '24px', fontWeight: 'bold', textAlign: 'right', color: '#444' }}>{row.Units}</TableCell>
                                    <TableCell style={{ minHeight: "36px", backgroundColor: tableHeaderColor?.isTotalColor, fontSize: '24px', fontWeight: 'bold', textAlign: 'right', color: '#444' }}>{row.Freight}</TableCell>
                                    {selectedFields.hasOwnProperty('CartageAmount') &&
                                        <TableCell style={{ minHeight: "36px", backgroundColor: tableHeaderColor?.isTotalColor, fontSize: '24px', fontWeight: 'bold', textAlign: 'right', color: '#444' }}>{row.CartageAmount}</TableCell>
                                    }
                                    {selectedFields.hasOwnProperty('HamaliCharge') &&
                                        <TableCell style={{ minHeight: "36px", backgroundColor: tableHeaderColor?.isTotalColor, fontSize: '24px', fontWeight: 'bold', textAlign: 'right', color: '#444' }}>{row.HamaliCharge}</TableCell>
                                    }
                                    {selectedFields.hasOwnProperty('OtherCharges') &&
                                        <TableCell style={{ minHeight: "36px", backgroundColor: tableHeaderColor?.isTotalColor, fontSize: '24px', fontWeight: 'bold', textAlign: 'right', color: '#444' }}>{row.OtherCharges}</TableCell>
                                    }
                                    {selectedFields.hasOwnProperty('Valuation') &&
                                        <TableCell style={{ minHeight: "36px", backgroundColor: tableHeaderColor?.isTotalColor, fontSize: '24px', fontWeight: 'bold', textAlign: 'right', color: '#444' }}>{row.Valuation}</TableCell>
                                    }
                                    {selectedFields.hasOwnProperty('BookingGST') &&
                                        <TableCell style={{ minHeight: "36px", backgroundColor: tableHeaderColor?.isTotalColor, fontSize: '24px', fontWeight: 'bold', textAlign: 'right', color: '#444' }}>{row.BookingGST}</TableCell>
                                    }
                                    {loginData?.intCompanyID !== RAJESH_TRANSPORT &&
                                        <TableCell style={{ minHeight: "36px", backgroundColor: tableHeaderColor?.isTotalColor, fontSize: '24px', fontWeight: 'bold', textAlign: 'right', color: '#444' }}>{row.NetAmount}</TableCell>
                                    }
                                    {loginData?.intCompanyID === RAJESH_TRANSPORT &&
                                        <TableCell style={{ minHeight: "36px", backgroundColor: tableHeaderColor?.isTotalColor }} ></TableCell>
                                    }
                                </TableRow> : row.isHeaderRow ?
                                    <TableRow key={`TH-${index}`}>
                                        {columnSummaryDefs.map((col, index) => (
                                            <TableCell
                                                key={`THR-${index}`}
                                                style={{
                                                    ...col.headerSx,
                                                    minHeight: "36px",
                                                    backgroundColor: tableHeaderColor?.isHeadingColor,
                                                    color: '#444',
                                                    fontSize: '24px',
                                                    fontWeight: '600',
                                                    whiteSpace: 'pre-line',
                                                    position: 'sticky',
                                                    top: "60px",
                                                }}
                                            >
                                                {col.header}
                                            </TableCell>))}
                                    </TableRow>
                                    : row.isSubHeadingRow ?
                                        <TableRow key={`SHRT-${index}`}>
                                            {row.isSubHeadingData.map((obj, index) => (
                                                <TableCell style={{ minHeight: "36px", backgroundColor: '#f1f9ff', position: 'sticky', top: "30px", fontSize: '24px', fontWeight: 'bold', textAlign: obj.align, color: '#444' }} key={`SH-${index}`} colSpan={index !== 2 ? Math.floor(columnSummaryDefs.length / 3) : columnSummaryDefs.length - Math.floor(columnSummaryDefs.length / 3) * 2}>{`${obj.caption}${obj.value}`}</TableCell>
                                            ))}
                                        </TableRow> : row.isNoData ?
                                            <TableRow>
                                                <TableCell colSpan={row.colSpan} align='center' sx={{ minHeight: "36px", fontSize: '24px', fontWeight: 'bold' }}>{row.caption}</TableCell>
                                            </TableRow> : null
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default BranchReceiveExcel